import type { SVGProps } from 'react';
const SvgComplete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.28 6.22a.751.751 0 0 1 0 1.062l-3.5 3.5a.75.75 0 0 1-1.062 0l-1.5-1.5a.751.751 0 1 1 1.063-1.063l.969.969 2.97-2.97a.75.75 0 0 1 1.06.001ZM15 8.25A6.75 6.75 0 1 1 8.25 1.5 6.758 6.758 0 0 1 15 8.25Zm-1.5 0a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0Z"
    />
  </svg>
);
export default SvgComplete;
